var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.516172 1.15087C0.158672 1.50837 0.158672 2.08587 0.516172 2.44337L4.07284 6.00004L0.516172 9.55671C0.158672 9.91421 0.158672 10.4917 0.516172 10.8492C0.873672 11.2067 1.45117 11.2067 1.80867 10.8492L6.01617 6.64171C6.37367 6.28421 6.37367 5.70671 6.01617 5.34921L1.80867 1.14171C1.46034 0.793374 0.873672 0.793374 0.516172 1.15087Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.3f14d593af9c08c4078caacde39da8fd.svg";
export { ForwardRef as ReactComponent };